import React from 'react';
import { Button, Space, Tag, notification } from 'antd';

import VehicleStatus from '../../../core/enum/VehicleStatus';
import { useUpdateVehicleStatusMutation } from '../../../app/api/vehicleApiSlice';
import { useRegisterVehicleForInspectionMutation } from '../../../app/api/inspectionApiSlice';
interface IProps {
  vehicleId: string;
  vehicleStatus: VehicleStatus;
}

const ChangeVehicleStatus: React.FC<IProps> = ({ vehicleId, vehicleStatus }) => {
  const [updateVehicleStatus, { isLoading }] = useUpdateVehicleStatusMutation();
  const [registerVehicleForInspection] = useRegisterVehicleForInspectionMutation();

  const registerVehicle = (): void => {
    updateStatus(VehicleStatus.Registered);
  };

  const updateStatus = (vehicleStatus: VehicleStatus): void => {
    void (async () => {
      try {
        await updateVehicleStatus({ id: vehicleId, status: vehicleStatus }).unwrap();

        notification.success({
          message: 'Status Update',
          description:
            vehicleStatus === VehicleStatus.Rejected
              ? 'Vehicle rejected'
              : 'Status updated successfully',
        });

        if (vehicleStatus === VehicleStatus.Approved) {
          registerForInspection();
        }
      } catch (error: any) {
        console.log(error);
      }
    })();
  };

  const registerForInspection = (): void => {
    void (async () => {
      try {
        await registerVehicleForInspection(vehicleId).unwrap();
        notification.success({
          message: 'Register for Grading Report',
          description: 'Successfully registered with the Grading System',
        });
      } catch (error: any) {
        console.log(error);
      }
    })();
  };

  const rejectVehicle = (): void => {
    updateStatus(VehicleStatus.Rejected);
  };

  const approveVehicle = (): void => {
    updateStatus(VehicleStatus.Approved);
  };

  const completeInspection = (): void => {
    updateStatus(VehicleStatus.GradingCompleted);
  };

  const approvePrice = (): void => {
    updateStatus(VehicleStatus.AuctionReady);
  };

  const reAuction = (): void => {
    updateStatus(VehicleStatus.GradingCompleted);
  };

  const withdraw = (): void => {
    updateStatus(VehicleStatus.Withdrawn);
  };

  const readyForDelivery = (): void => {
    updateStatus(VehicleStatus.DeliveryReady);
  };

  const delivered = (): void => {
    updateStatus(VehicleStatus.Delivered);
  };

  switch (vehicleStatus) {
    case VehicleStatus.New:
      return (
        <Button type='primary' danger onClick={registerVehicle} loading={isLoading}>
          Register
        </Button>
      );
    case VehicleStatus.Registered:
      return (
        <Space>
          <Button type='ghost' danger onClick={rejectVehicle}>
            Reject
          </Button>
          <Button type='primary' danger onClick={approveVehicle} loading={isLoading}>
            Approve
          </Button>
        </Space>
      );
    case VehicleStatus.Rejected:
      return <Tag color='purple'>Rejected by the Admin</Tag>;
    case VehicleStatus.Approved:
      return (
        <Button type='ghost' danger onClick={completeInspection} loading={isLoading}>
          Complete Grading
        </Button>
      );
    case VehicleStatus.GradingCompleted:
      return <Tag color='purple'>Waiting for Seller Price</Tag>;
    case VehicleStatus.PriceListed:
      return (
        <Button type='ghost' danger onClick={approvePrice} loading={isLoading}>
          Approve Price
        </Button>
      );
    case VehicleStatus.AuctionReady:
      return <Tag color='purple'>Vehicle ready for auction</Tag>;
    case VehicleStatus.Sold:
      return (
        <Button type='ghost' danger onClick={readyForDelivery} loading={isLoading}>
          Ready for Delivery
        </Button>
      );
    case VehicleStatus.DeliveryReady:
      return (
        <Button type='ghost' danger onClick={delivered} loading={isLoading}>
          Delivered
        </Button>
      );
    case VehicleStatus.Delivered:
      return <Tag color='purple'>Vehicle Delivered</Tag>;
    case VehicleStatus.Unsold:
      return (
        <Space>
          <Button type='primary' danger onClick={reAuction} loading={isLoading}>
            Auction Again
          </Button>
          <Button type='ghost' danger onClick={withdraw} loading={isLoading}>
            Withdraw
          </Button>
        </Space>
      );
    case VehicleStatus.Withdrawn:
      return <Tag color='purple'>Vehicle withdrawn</Tag>;
    default:
      return <></>;
  }
};

export default ChangeVehicleStatus;
